import { z } from "zod";

/** Arquivo das exportações em massa (T1.15): CSV (padrão, ";" e BOM) ou Excel (.xlsx). */
export const EXPORT_FILE_FORMATS = ["csv", "xlsx"] as const;
export type ExportFileFormat = (typeof EXPORT_FILE_FORMATS)[number];
export const exportFileFormat = z.enum(EXPORT_FILE_FORMATS).default("csv");
